import { createSlice } from '@reduxjs/toolkit'
import { getGeofencingZones } from './geofencingZonesActions'

const ZONE_BUCKETS = ['grayArea', 'speedLimitZones', 'noParkingZones', 'parkingZones']

const initialState = {
  loading: false,
  geofencingZonesData: {
    grayArea: { type: 'FeatureCollection', features: [] },
    speedLimitZones: { type: 'FeatureCollection', features: [] },
    noParkingZones: { type: 'FeatureCollection', features: [] },
    parkingZones: { type: 'FeatureCollection', features: [] },
  },
  error: null,
  success: false,
}

// Cheap "did anything in this bucket change?" check. Compares the ordered set
// of feature ids + a content fingerprint of each feature. Doesn't try to be
// clever — full JSON.stringify of the features array would also work but
// allocates a giant string; this iterates once and bails early on the first
// difference. Zones rarely change (every 15 minutes refresh, mostly identical),
// so most calls return true.
function bucketsEqual(a, b) {
  const fa = a?.features ?? []
  const fb = b?.features ?? []
  if (fa.length !== fb.length) return false
  for (let i = 0; i < fa.length; i++) {
    if (fa[i].properties?.id !== fb[i].properties?.id) return false
    if (fa[i].properties?.color !== fb[i].properties?.color) return false
    // Geometry changes are rare; if they do, fall through to JSON compare.
    if (JSON.stringify(fa[i].geometry) !== JSON.stringify(fb[i].geometry)) return false
  }
  return true
}

const geofencingZonesSlice = createSlice({
  name: 'geofencingZones',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getGeofencingZones.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getGeofencingZones.fulfilled, (state, action) => {
        state.loading = false
        state.success = true

        // Per-bucket reference stability: only swap a bucket's reference if its
        // contents actually changed. Unchanged buckets keep their previous
        // reference so the VehiclesMap useEffect can skip the corresponding
        // source.setData call (avoids needless polygon re-renders / flicker).
        const incoming = action.payload ?? {}
        for (const bucket of ZONE_BUCKETS) {
          const next = incoming[bucket]
          if (!next) continue
          if (!bucketsEqual(state.geofencingZonesData[bucket], next)) {
            state.geofencingZonesData[bucket] = next
          }
        }
      })
      .addCase(getGeofencingZones.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
        state.success = false
      })
  },
})

export default geofencingZonesSlice.reducer
